<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.34993 15.5181C5.28701 15.8598 7.18836 14.7535 7.8581 12.8949L7.90188 12.9059C10.8792 13.0709 12.8714 14.3362 13.9661 16.7016C12.5257 17.543 11.9161 19.3181 12.5334 20.8734C13.1507 22.4287 14.8085 23.2947 16.4296 22.9085C18.0507 22.5224 19.1456 21.0007 19.0028 19.3324C18.86 17.6641 17.5226 16.3527 15.8598 16.2505H15.6723C14.8935 14.6963 13.6667 13.4112 12.149 12.5648H16.418C16.9249 14.1546 18.5083 15.1365 20.1493 14.8786C21.7903 14.6208 23 13.2 23 11.5306C23 9.86118 21.7903 8.44047 20.1493 8.18262C18.5083 7.92478 16.9249 8.90663 16.418 10.4964H12.1381C13.674 9.63991 14.912 8.33398 15.6892 6.75465C17.3467 6.71094 18.7289 5.4559 18.9349 3.79625C19.1433 2.11684 18.083 0.54165 16.4545 0.111454C14.8259 -0.318741 13.1321 0.528885 12.492 2.09428C11.852 3.65968 12.4634 5.45952 13.9223 6.3046V6.39262C12.8496 8.75808 10.8355 10.0013 7.8581 10.1223C7.18836 8.26376 5.28701 7.15739 3.34993 7.49911C1.41286 7.84084 0 9.53187 0 11.5086C0 13.4853 1.41286 15.1764 3.34993 15.5181ZM13.8343 19.6827C13.8223 18.6663 14.6291 17.8309 15.6403 17.8127C16.1336 17.8039 16.6099 17.9947 16.9619 18.3423C17.3139 18.6899 17.5121 19.1651 17.5121 19.6611C17.5119 20.6776 16.6952 21.5032 15.6839 21.5091C14.6726 21.515 13.8463 20.6991 13.8343 19.6827ZM19.6143 9.70459C18.5987 9.70459 17.7754 10.5321 17.7754 11.5529C17.7754 12.5738 18.5987 13.4013 19.6143 13.4013C20.63 13.4013 21.4533 12.5738 21.4533 11.5529C21.4533 10.5321 20.63 9.70459 19.6143 9.70459ZM13.8343 3.37784C13.8223 2.36143 14.6291 1.52602 15.6403 1.50787C16.1336 1.49902 16.6099 1.68984 16.9619 2.03744C17.3139 2.38503 17.5121 2.86024 17.5121 3.35623C17.5119 4.37272 16.6952 5.19832 15.6839 5.2043C14.6726 5.21021 13.8463 4.39426 13.8343 3.37784Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgNYSSCPAChapters',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>